import { ReactElement } from "react";
import { Icon, SvgIconValue } from "../Icon/Icon";
import classNames from "classnames";
import styles from "./PersonAvatarIcon.module.less";

export type PersonAvatarIconSize =
	| "x-small"
	| "small"
	| "default"
	| "large"
	| "x-large"
	| "xx-large"
	| "xxx-large";

const sizeToStyle: {[key in PersonAvatarIconSize]: string | null} = {
	"x-small": styles.root_xSmall,
	"small": styles.root_small,
	"default": null,
	"large": styles.root_large,
	"x-large": styles.root_xLarge,
	"xx-large": styles.root_xxLarge,
	"xxx-large": styles.root_xxxLarge
};

export type PersonAvatarIconProps = {
	icon: SvgIconValue;
	title?: string;
	size?: PersonAvatarIconSize;
};

export const PersonAvatarIcon = (props: PersonAvatarIconProps): ReactElement => {
	const {
		icon,
		title,
		size = "default"
	} = props;

	return (
		<div
			className={classNames(
				styles.root,
				sizeToStyle[size]
			)}
			title={title}
		>
			{icon && (
				<Icon value={icon} />
			)}
		</div>
	);
};
PersonAvatarIcon.displayName = "PersonAvatarIcon";
